import { httpsCallable } from 'firebase/functions';
import {
  db,
  functions,
  collection,
  query,
  orderBy,
  limit,
  getDocs,
} from '../config/firebase';

const callSendAdminNotification = httpsCallable(functions, 'sendAdminNotification');

/**
 * Send an admin push notification.
 * target: { type: 'broadcast' | 'role' | 'user', role?, userIds? }
 */
export const sendAdminNotification = async ({ title, body, target, data = {} }) => {
  if (!title || !body) throw new Error('Title and body are required');
  if (!target?.type) throw new Error('Target type is required');
  const res = await callSendAdminNotification({ title, body, target, data });
  return res.data;
};

export const sendBroadcastNotification = (title, body, data = {}) =>
  sendAdminNotification({ title, body, target: { type: 'broadcast' }, data });

export const sendRoleNotification = (role, title, body, data = {}) =>
  sendAdminNotification({ title, body, target: { type: 'role', role }, data });

export const sendUserNotification = (userIds, title, body, data = {}) =>
  sendAdminNotification({
    title,
    body,
    target: { type: 'user', userIds: Array.isArray(userIds) ? userIds : [userIds] },
    data,
  });

export const getNotificationHistory = async (count = 50) => {
  const q = query(
    collection(db, 'adminNotifications'),
    orderBy('createdAt', 'desc'),
    limit(count)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const notificationTemplates = {
  welcome: {
    title: 'Welcome to Dierend!',
    body: 'Thank you for joining our community of pet lovers.',
  },
  newFeature: {
    title: 'New Feature Available!',
    body: 'Check out our latest update with exciting new features.',
  },
  maintenance: {
    title: 'Scheduled Maintenance',
    body: 'The app will be temporarily unavailable for maintenance.',
  },
  promotion: {
    title: 'Special Offer!',
    body: 'Check out our exclusive deals for your furry friends!',
  },
};

const notificationService = {
  sendAdminNotification,
  sendBroadcastNotification,
  sendRoleNotification,
  sendUserNotification,
  getNotificationHistory,
  notificationTemplates,
};

export default notificationService;
